(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ResultReport', ResultReport);

    ResultReport.$inject = ['$resource'];

    function ResultReport ($resource) {
        var resourceUrl =  'api/result-reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
